import { Text, VStack } from 'ui_2';
import { BiChevronLeft, BiX } from 'react-icons/bi';
import { useBreakpoints } from '@puzzlehq/frontend-utils';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { ReactNode } from 'react';
import { FileRouteTypes, Link } from '@tanstack/react-router';

type HeaderProps = {
  title?: string | ReactNode;
  close?: boolean;
  backRoute: FileRouteTypes['to'];
  onClick?: () => void;
};

const Header = ({ onClick, title, backRoute, close = false }: HeaderProps) => {
  const { isMedium } = useBreakpoints();
  const { isPuzzleWalletWebview } = useArcadeStoreState();

  return (
    <VStack className='w-full gap-2 px-4'>
      <div className='flex w-full items-center'>
        {/* left */}
        <div className='flex justify-start'>
          {!close && isPuzzleWalletWebview === false && (
            <Link to={backRoute} onClick={onClick}>
              <BiChevronLeft
                size={isMedium ? 40 : 24}
                className={'text-black md:-ml-3'}
              />
            </Link>
          )}
          {close && isPuzzleWalletWebview === false && (
            <Link to={backRoute} onClick={onClick}>
              <BiX
                size={isMedium ? 40 : 24}
                className={'text-black md:-ml-3'}
              />
            </Link>
          )}
        </div>
        {/* center on mobile, left on desktop */}
        <div className='flex-1 text-center md:ml-4 md:text-left'>
          {typeof title === 'string' ? (
            <Text font={isMedium ? 'bold-lg' : 'bold-md'}>{title}</Text>
          ) : (
            title
          )}
        </div>
        {/* right - Empty space */}
        <div className='w-6 md:hidden' />
      </div>
    </VStack>
  );
};
export default Header;
